package ru.malygin.urls.url

class GetScheduleChangeList {
    val urlHead = "/getScheduleChangeList"
}